import type { ReactNode } from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface Accion {
  label: string;
  icono: ReactNode;
  onClick: () => void;
  variant?: "outline" | "secondary" | "default";
}

/** Botones en desktop, menú de acciones (⋯) en móvil. */
export function AccionesMenu({ acciones }: { acciones: Accion[] }) {
  return (
    <div className="no-print">
      <div className="hidden gap-2 sm:flex">
        {acciones.map((a) => (
          <Button key={a.label} size="sm" variant={a.variant ?? "outline"} onClick={a.onClick}>
            <span className="mr-1.5">{a.icono}</span>
            {a.label}
          </Button>
        ))}
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="sm:hidden">
          <Button variant="outline" size="icon" aria-label="Más acciones" className="h-11 w-11">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {acciones.map((a) => (
            <DropdownMenuItem key={a.label} onClick={a.onClick} className="gap-2 py-2.5">
              {a.icono}
              {a.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
